/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
  useBlockProps,
  InspectorControls,
  PanelColorSettings,
  AlignmentControl,
  BlockControls
} from "@wordpress/block-editor";
import {
  PanelBody,
  ToggleControl,
  RangeControl,
  SelectControl,

} from "@wordpress/components";
import { Fragment } from "@wordpress/element";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";
import ServerSideRender from "@wordpress/server-side-render";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */

export default function Edit({ attributes, setAttributes, clientId }) {
  const {
    chooseIcon,
    showIcon,
    iconPosition,
    iconSize,
    iconColor,
    textColor,
    fontSize,
    gap,
    textAlign,
  } = attributes;
  const icon2 = (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-more"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /><path d="M8 10h.01" /><path d="M12 10h.01" /><path d="M16 10h.01" /></svg>)
  return (
    <div {...useBlockProps()}>
      <Fragment>
        <BlockControls>
          <AlignmentControl
            value={textAlign}
            onChange={(nextAlign) => {
              setAttributes({ textAlign: nextAlign });
            }}
          />
        </BlockControls>
        <InspectorControls>
          <PanelBody
            title={__('Label settings', 'templazee')}
            initialOpen={true}
          >
            <PanelColorSettings
              title={__("Color Settings")}
              colorSettings={[
                {
                  value: textColor,
                  onChange: (newColor) => setAttributes({ textColor: newColor }),
                  label: __("Text Color"),
                },
                ...(showIcon
                  ? [
                    {
                      value: iconColor,
                      onChange: (newColor) => setAttributes({ iconColor: newColor }),
                      label: __("Icon Color"),
                    },
                  ]
                  : []),
              ]}
            />

            <ToggleControl
              label={__('Show Icon', 'templazee')}
              checked={showIcon}
              onChange={(isRemove) => setAttributes({ showIcon: isRemove })}
            />

            {showIcon && (
              <>

                <SelectControl
                  label={__('Select Position', 'templazee')}
                  value={iconPosition}
                  options={[
                    { label: __('Before', 'templazee'), value: 'before' },
                    { label: __('After', 'templazee'), value: 'after' },
                  ]}
                  onChange={(newValue) => setAttributes({ iconPosition: newValue })}
                />

              </>
            )}

          </PanelBody>
        </InspectorControls>
      </Fragment>
      <ServerSideRender
        block="templazee/comment-count"
        attributes={attributes}
      />
    </div>
  );
}
